import {NavLink} from './types';
import {Routes} from '../../constants/routes';
import i18n from 'i18n';
import {alpha} from '@mui/material/styles';
import {styled} from '@mui/material';
import {WellStatus} from '@features/wells/types';

export const getNavLinks = (wellId?: string): NavLink[] => {
    const tablesLink = wellId
        ? `${Routes.Tables}/${wellId}${Routes.CommonReportInformations}`
        : Routes.Wells;

    const dashboardLink = wellId ? `${Routes.Dashboard}/${wellId}` : Routes.Dashboard;

    return [
        {
            name: i18n.t('tables', {ns: 'header'}),
            link: tablesLink,
        },
        {
            name: i18n.t('dashboard', {ns: 'header'}),
            link: dashboardLink,
        },
    ];
};

export enum WellGroupKey {
    Active = 'wellGroup.active',
    Inactive = 'wellGroup.inactive',
    Completed = 'wellGroup.completed',
    Planned = 'wellGroup.planned',
    Other = 'wellGroup.other',
}

export const getGroupByStatus = (status: WellStatus): WellGroupKey | undefined => {
    const active = new Set([
        WellStatus.Drilling,
        WellStatus.Development,
        WellStatus.VMR,
        WellStatus.Moving,
    ]);

    const inactive = new Set([
        WellStatus.Inactive,
        WellStatus.Conservation,
        WellStatus.SuspendedDueToAdvancedDrilling,
        WellStatus.WaitForDevelopment,
    ]);

    if (active.has(status)) return WellGroupKey.Active;
    if (inactive.has(status)) return WellGroupKey.Inactive;
    if (status === WellStatus.Completed) return WellGroupKey.Completed;
    if (status === WellStatus.Planned) return WellGroupKey.Planned;

    return WellGroupKey.Other;
};

export const GroupHeader = styled('div')(({theme}) => ({
    position: 'sticky',
    top: '-8px',
    padding: '4px 10px',
    color: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
    zIndex: 1,
    backdropFilter: 'blur(3px)',
    fontSize: '0.75rem',
}));
